const doc = [({"name":"Rust Analyser", "summary":"A Rust compiler front-end for IDEs", "icon":"server", "repositories":[({"rust-lang/rust-analyser":"good first issue"})]})];
module.exports = doc.length <= 1 ? doc[0] : doc;